var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDotsAppIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77087 5.625C7.21757 5.625 5.95837 6.8842 5.95837 8.4375C5.95837 9.9908 7.21757 11.25 8.77087 11.25C10.3242 11.25 11.5834 9.9908 11.5834 8.4375C11.5834 6.8842 10.3242 5.625 8.77087 5.625ZM3.45837 8.4375C3.45837 5.50349 5.83686 3.125 8.77087 3.125C11.7049 3.125 14.0834 5.50349 14.0834 8.4375C14.0834 11.3715 11.7049 13.75 8.77087 13.75C5.83686 13.75 3.45837 11.3715 3.45837 8.4375Z",
    fill: "#10A37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8959 5.625C20.3426 5.625 19.0834 6.8842 19.0834 8.4375C19.0834 9.9908 20.3426 11.25 21.8959 11.25C23.4491 11.25 24.7084 9.9908 24.7084 8.4375C24.7084 6.8842 23.4491 5.625 21.8959 5.625ZM16.5834 8.4375C16.5834 5.50349 18.9619 3.125 21.8959 3.125C24.8299 3.125 27.2084 5.50349 27.2084 8.4375C27.2084 11.3715 24.8299 13.75 21.8959 13.75C18.9619 13.75 16.5834 11.3715 16.5834 8.4375Z",
    fill: "#10A37F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77087 18.75C7.21757 18.75 5.95837 20.0093 5.95837 21.5625C5.95837 23.1157 7.21757 24.375 8.77087 24.375C10.3242 24.375 11.5834 23.1157 11.5834 21.5625C11.5834 20.0093 10.3242 18.75 8.77087 18.75ZM3.45837 21.5625C3.45837 18.6285 5.83686 16.25 8.77087 16.25C11.7049 16.25 14.0834 18.6285 14.0834 21.5625C14.0834 24.4965 11.7049 26.875 8.77087 26.875C5.83686 26.875 3.45837 24.4965 3.45837 21.5625Z",
    fill: "#10A37F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8959 18.75C20.3426 18.75 19.0834 20.0092 19.0834 21.5625C19.0834 23.1157 20.3426 24.375 21.8959 24.375C23.4491 24.375 24.7084 23.1157 24.7084 21.5625C24.7084 20.0092 23.4491 18.75 21.8959 18.75ZM16.5834 21.5625C16.5834 18.6285 18.9619 16.25 21.8959 16.25C24.8299 16.25 27.2084 18.6285 27.2084 21.5625C27.2084 24.4965 24.8299 26.875 21.8959 26.875C18.9619 26.875 16.5834 24.4965 16.5834 21.5625Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDotsAppIcon);
export default __webpack_public_path__ + "static/media/GreenDotsAppIcon.024d7dba5a261a350270304ee8a995e7.svg";
export { ForwardRef as ReactComponent };